module.exports = __webpack_public_path__ + "static/img/img1.7d91210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/img1.png
// module id = +bUj
// module chunks = 0